import { render, staticRenderFns } from "./PortfolioProject.vue?vue&type=template&id=5bb4ab16&scoped=true&"
import script from "./PortfolioProject.vue?vue&type=script&lang=js&"
export * from "./PortfolioProject.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioProject.vue?vue&type=style&index=0&id=5bb4ab16&prod&lang=scss&scoped=true&"
import style1 from "./PortfolioProject.vue?vue&type=style&index=1&id=5bb4ab16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb4ab16",
  null
  
)

export default component.exports